import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from './baseQueryWithReauth';

export const jobApi = createApi({
  reducerPath: 'jobApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    updateJobEmailWhenCompleted: builder.mutation<any, { jobId: string, emailWhenCompleted: boolean, isExporting: boolean }>({
      query: ({ jobId, emailWhenCompleted, isExporting }) => ({
        url: `job/${jobId}/ExportEmail`,
        method: 'PUT',
        body: { emailWhenCompleted, isExporting },
      }),
    }),
  }),
});

export const { useUpdateJobEmailWhenCompletedMutation } = jobApi;
